import { Box, Grid, ButtonGroup, Button, Typography, CircularProgress } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useState } from "react";
import ViewAllCardsCommon from "./ViewAllCardsCommon";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import CreateContentModal from "./CreateContentModal";
import { CustomPaginationCommon } from "modules/Users/components";
import { ContentsService } from "services/ContentsService";

const MyContentData = ({ allContentsData, setAllContentsData, isloading }: any) => {
  const [selectedTab, setSelectedTab] = useState("View All");
  const [isModalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);


  const navigation = useNavigate();

  // Mock data for View All tab
  const handoutData = allContentsData.filter(
    (content: any) => content.type === "handout"
  );
  const courseData = allContentsData.filter(
    (content: any) => content.type === "course"
  );

  // Combine handouts and courses for "View All" tab
  const combinedAllData = [...handoutData, ...courseData];

  // Filter content based on selected tab
  const filteredContentData = () => {
    if (selectedTab === "Handouts") {
      return allContentsData.filter(
        (content: any) => content.type === "handout"
      );
    } else if (selectedTab === "Courses") {
      return allContentsData.filter(
        (content: any) => content.type === "course"
      );
    }
    return allContentsData; // Default is 'View All'
  };

  // Get paginated data for current page
  const paginatedData = filteredContentData().slice(
    (page - 1) * itemsPerPage, // Change to 1-based page
    page * itemsPerPage
  );

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    newPage: number
  ) => {
    setPage(newPage); // newPage will now be 1-based
  };

  const handleEditClick = (id: number) => {

    navigation(`/create-content/handout?id=${id}`);
  };

  const handleEditCourseClick = (id: number) => {

    navigation(`/create-content/course?id=${id}`);
  };

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    setPage(1);
  };
  const buttonStylesMob = (tab: string) => ({
    color: selectedTab === tab ? "#233F91" : "#6C6C6C",
    backgroundColor: "transparent",
    borderRadius: "0",
    padding: "0",
    minWidth: "auto",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "0",
      right: "0",
      bottom: "-0px",
      height: "6px",
      backgroundColor: selectedTab === tab ? "#233F91" : "transparent",
      borderRadius: "6px",
      transition: "background-color 0.3s ease",
    },
    "&:hover::after": {
      backgroundColor: selectedTab === tab ? "#233F91" : "transparent",
    },
    fontSize: "18px",
    fontWeight: selectedTab === tab ? "700px" : "700px",
  });

  const buttonStyles = (tab: string) => ({
    backgroundColor: selectedTab === tab ? "#233F91" : "transparent",
    color: selectedTab === tab ? "#fff" : "#797979",
    borderColor: selectedTab === tab ? "#233F91" : "#ccc",
    borderRadius: "20px",
    textTransform: "none",
    width: "103px",
    height: "33px",
    padding: "4px, 14.2px, 4px, 14.2px",

    "&:hover": {
      backgroundColor: selectedTab === tab ? "#233F91" : "transparent",
    },
  });

  // Handle the Edit button click for content
  const handleEditContent = (id: number) => {
    const content = combinedAllData.find((item) => item.id === id);
    if (content) {
      if (content.type === "handout") {
        navigation(`/create-content/handout?id=${id}`);
      } else if (content.type === "course") {
        navigation(`/create-content/course?id=${id}`);
      }
    }
  };

  const handleButtonClick = () => {
  };

  const handleNavigateHandout = (id: number) => {
    navigation("/create-content/handout");
  };

  const handleNavigateCourse = () => {
    navigation(`/create-content/course`);
  };

  const handleCreateHandout = () => {
    navigation("/education-content-handout");
  };

  const handleCreateCourse = () => {
    navigation(`/education-content-course`);
  };
  const handleCreateContentClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // const getPaginatedData = (data: any[]) => {
  //     const startIndex = (page - 1) * itemsPerPage;
  //     return data.slice(startIndex, startIndex + itemsPerPage);
  // };

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        gap={3}
        px={{ xs: 2, md: "55px" }}
        overflow={"hidden"}
      >
        <Box
          pt={{ xs: 17, md: 5 }}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            fontWeight={500}
            fontSize={{ xs: "20px", md: "28px" }}
            color="#233F91"
            display="flex"
            alignItems="center"
          >
            My Content
          </Box>
          <Button
            onClick={handleCreateContentClick}
            sx={styleSheet.addNewBtnMob}
          >
            <AddIcon />
            Create Content
          </Button>
        </Box>

        <Box display={"flex"} justifyContent={"space-between"}>
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            {/* /// full screen display /// */}
            <Box sx={styleSheet.optionsFullScreen}>
              <Button
                onClick={() => handleTabChange("View All")}
                sx={buttonStyles("View All")}
              >
                View All
              </Button>
              <Box sx={styleSheet.rightBorder}></Box>
              <Button
                onClick={() => handleTabChange("Handouts")}
                sx={buttonStyles("Handouts")}
              >
                Handouts
              </Button>
              <Box sx={styleSheet.rightBorder}></Box>

              <Button
                onClick={() => handleTabChange("Courses")}
                sx={buttonStyles("Courses")}
              >
                Courses
              </Button>
            </Box>
            {/* /// mobile screen display /// */}
            <Box sx={styleSheet.optionsFullScreenMob}>
              {/* <Box display={"flex"} gap={7}> */}
              <Button
                onClick={() => handleTabChange("View All")}
                sx={buttonStyles("View All")}
              >
                View All
              </Button>
              <Box sx={styleSheet.rightBorder}></Box>
              <Button
                onClick={() => handleTabChange("Handouts")}
                sx={buttonStyles("Handouts")}
              >
                Handouts
              </Button>
              <Box sx={styleSheet.rightBorder}></Box>
              <Button
                onClick={() => handleTabChange("Courses")}
                sx={buttonStyles("Courses")}
              >
                Courses
              </Button>
            </Box>
            {/* </Box> */}
          </Box>
          <Button onClick={handleCreateContentClick} sx={styleSheet.addNewBtn}>
            <AddIcon />
            Create Content
          </Button>
        </Box>
        <CreateContentModal
          open={isModalOpen}
          onClose={handleCloseModal}
          onCourseClick={handleNavigateCourse}
          onHandoutClick={handleNavigateHandout}
          heading="What's the Type of Content You're Creating Today?"
          buttonText1="Course"
          buttonText2="Handout"
        />
        {isloading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
          // width="100vw"
          >
            <CircularProgress sx={{ color: "#233F91" }} />
          </Box>

        ) : paginatedData.length === 0 ? (
          <Box
            flex={1}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          // width="100vw"
          >
            <Typography
              display="flex"
              alignItems="center"
              fontSize={22}
              color="#797979"
              fontWeight={400}
            >
              No content available
            </Typography>
          </Box>
        ) : (
          <>
            {selectedTab === "View All" && (
              <Box mt={3}>
                {/* {paginatedData && paginatedData.length > 0 ? ( */}
                <ViewAllCardsCommon
                  data={paginatedData} // Dynamically loaded combinedAllData
                  onCreateContent={handleCreateHandout}
                  onEditContent={handleEditContent}
                  titleColor="#233F91"
                  cardBorderRadius="10px"
                  buttonBackgroundColor="#233F91"
                />
                {/* ) : (
              <Typography variant="body1" color="textSecondary">
                No content available
              </Typography>
            )} */}
              </Box>
            )}
          </>
        )}

        {isloading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
          // width="100vw"
          >
            <CircularProgress sx={{ color: "#233F91" }} />
          </Box>

        ) : allContentsData?.length === 0 ? (
          <Box
            flex={1}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
          // width="100vw"
          >
            <Typography
              display="flex"
              alignItems="center"
              fontSize={22}
              color="#797979"
              fontWeight={400}
            >
              No handout data available
            </Typography>
          </Box>
        ) : (
          <>
            {selectedTab === "Handouts" && (
              <Box mt={3}>
                {/* {allContentsData && allContentsData.length > 0 ? ( */}
                <ViewAllCardsCommon
                  data={handoutData} // Dynamically loaded handOutData
                  onCreateContent={handleCreateHandout}
                  onEditContent={handleEditClick}
                  titleColor="#233F91"
                  cardBorderRadius="10px"
                  buttonBackgroundColor="#233F91"
                />
                {/* // ) : (
            //   <Typography variant="body1" color="textSecondary">
            //     No handout data available
            //   </Typography>
            // )} */}
              </Box>
            )}
          </>
        )}


        {isloading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
          // width="100vw"
          >
            <CircularProgress sx={{ color: "#233F91" }} />
          </Box>

        ) : allContentsData?.length === 0 ? (
          <Box
            flex={1}
            display="flex"
            alignItems={"center"}
            justifyContent={"center"}
            width="100vw"
          >
            <Typography
              display="flex"
              alignItems="center"
              fontSize={22}
              color="#797979"
              fontWeight={400}
            >
              No course data available
            </Typography>
          </Box>
        ) : (
          <>
            {selectedTab === "Courses" && (
              <Box mt={3}>
                {/* {allContentsData && allContentsData.length > 0 ? ( */}
                <ViewAllCardsCommon
                  data={courseData} // Dynamically loaded courseData
                  onCreateContent={handleCreateHandout}
                  onEditContent={handleEditCourseClick}
                  titleColor="#233F91"
                  cardBorderRadius="10px"
                  buttonBackgroundColor="#233F91"
                />
                {/* ) : (
              <Typography variant="body1" color="textSecondary">
                No course data available
              </Typography>
            )} */}
              </Box>
            )}
          </>
        )}

        <Box sx={styleSheet.pagginationContainer}>

          <CustomPaginationCommon
            count={Math.ceil(filteredContentData().length / itemsPerPage)}
            page={page}
            rowsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </Box>
      </Grid >
    </>
  );
};

export default MyContentData;

const styleSheet = {
  addNewBtn: {
    borderRadius: "15px",
    width: "186px",
    height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: "15px",
    fontWeight: 700,
    display: { xs: "none", md: "flex" },
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  addNewBtnMob: {
    borderRadius: "15px",
    width: { xs: "138px", md: "155px" },
    // height: "48px",
    textTransform: "none",
    backgroundColor: "#ffffff",
    border: "1px solid #233f91",
    color: "#233f91",
    fontSize: { xs: "13px", md: "15px" },
    fontWeight: 700,
    display: { xs: "flex", md: "none" },
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },
  optionsFullScreen: {
    display: { xs: "none", md: "flex" },
    gap: 1,
    alignItems: "center",
    border: "1px solid #BFBFBF",
    borderRadius: "20px",
    px: "2.84px",
    width: "299px",
    height: "39.2px",
    bgcolor: "#EDEDED",
  },
  rightBorder: {
    width: "1px",
    height: "17.03px",
    bgcolor: "#BFBFBF",
  },
  pagginationContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "20px",
  },

  /// for mobile view

  optionsFullScreenMob: {
    display: { xs: "flex", md: "none" },
    gap: 1,
    alignItems: "center",
    border: "1px solid #BFBFBF",
    borderRadius: "20px",
    px: "2.84px",
    width: { xs: "280px", md: "299px" },
    height: "39.2px",
    bgcolor: "#EDEDED",
  },
};
